import { cn } from '@/lib/utils'

interface CreditIconProps {
  className?: string
  strokeWidth?: number
}

/**
 * Custom credit icon — sparkle inside a circle.
 * Uses currentColor so it inherits text color and adapts to both light and dark themes.
 */
export function CreditIcon({ className, strokeWidth = 1 }: CreditIconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('flex-shrink-0', className)}
      aria-hidden="true"
    >
      <circle cx="7.5" cy="7.5" r="7" stroke="currentColor" strokeWidth={strokeWidth} />
      <path
        d="M7.19307 3.82947C7.2985 3.54455 7.7015 3.54454 7.80693 3.82947L8.19317 4.87326C8.52465 5.76906 9.23094 6.47535 10.1267 6.80683L11.1705 7.19307C11.4555 7.2985 11.4555 7.7015 11.1705 7.80693L10.1267 8.19317C9.23094 8.52465 8.52465 9.23094 8.19317 10.1267L7.80693 11.1705C7.7015 11.4555 7.2985 11.4555 7.19307 11.1705L6.80683 10.1267C6.47535 9.23094 5.76906 8.52465 4.87326 8.19317L3.82947 7.80693C3.54455 7.7015 3.54454 7.2985 3.82947 7.19307L4.87326 6.80683C5.76906 6.47535 6.47535 5.76906 6.80683 4.87326L7.19307 3.82947Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}
